import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './List.scss'

const List = ({ header, info, body, footer, bodyPadding, noBorders }) => (
	<div styleName="list">
		{header ? (
			<div styleName={noBorders ? 'header-clean' : 'header'}>
				<div styleName="title">{header}</div>
				<div styleName="info">{info}</div>
			</div>
		) : (
			''
		)}

		<div styleName={bodyPadding ? 'body-padding' : 'body'}>{body}</div>

		{footer ? (
			<div styleName={noBorders ? 'footer-clean' : 'footer'}>
				{footer}
			</div>
		) : (
			''
		)}
	</div>
)

List.propTypes = {
	header: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	info: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	body: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	]),
	footer: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	])
}

export default CSSModules(List, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/List.js